import { Image } from '../../../components/image/Image';
import { classes } from '../../../utils/commonUtils';
import css from './details-background.module.scss';

interface DetailsBackgroundProps extends React.HTMLAttributes<HTMLDivElement> {
  src: string;
  children?: React.ReactNode;
}

export function DetailsBackground({ src, children }: DetailsBackgroundProps) {
  return (
    <>
      <div className={css.backgroundImage}>
        <Image src={src} alt="" />
        <div className={css.overlayGradient} />
      </div>
      {children}
    </>
  );
}

function DetailsBackgroundSkeleton() {
  return (
    <div className={classes(css.backgroundImage, css.skeleton)}>
      <div className={css.overlayGradient} />
    </div>
  );
}

DetailsBackground.Skeleton = DetailsBackgroundSkeleton;
